<template>
    <v-row class="row--xs">
        <v-col cols="">
            <v-text-field v-model="query['searchValue']" v-bind="{ loading }" dense hide-details outlined append-icon="mdi-magnify" placeholder="상품명을 검색하세요." @keydown.enter="emit" />
        </v-col>
        <v-col cols="auto">
            <v-btn v-bind="{ loading }" color="grey" class="rounded-sm" @click="emit">조회</v-btn>
        </v-col>
    </v-row>
</template>

<script>
const initQuery = (query) => ({
    ...(query || {}),

    ["searchValue"]: query?.["searchValue"] || null,
});
export default {
    components: {},
    props: {
        loading: { type: Boolean, default: false },
    },
    setup: () => ({}),
    data: () => ({
        query: initQuery(),
    }),
    computed: {},
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query["page"];

            if (!query["searchValue"]) delete query["searchValue"];

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped></style>
